"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const assets_1 = require("~/assets");
const accountTabs_1 = require("~/consts/accountTabs");
const consts_1 = require("~/store/account/consts");
const actions_1 = require("~/store/actions");
const actions_2 = require("~/store/address/actions");
const selectors_1 = require("~/store/selectors");
const useCurrentAccountTabId_1 = __importDefault(require("~/hooks/useCurrentAccountTabId"));
const ElementDropdown_1 = require("~/components/UI/ElementDropdown");
const AdminProfileView_1 = __importDefault(require("~/components/Account/AdminProfileView"));
const react_helmet_async_1 = require("react-helmet-async");
const ChangeCredentials_1 = require("../ChangeCredentials/ChangeCredentials");
const CustomerProfileView_1 = __importDefault(require("../CustomerProfileView"));
const DistributorProfileView_1 = __importDefault(require("../DistributorProfileView"));
const EditProfileDropdown_1 = __importDefault(require("../EditProfileDropdown/EditProfileDropdown"));
const ProfileHeadline_1 = __importDefault(require("../ProfileHeadline/ProfileHeadline"));
const ProfileModal_module_scss_1 = __importDefault(require("./ProfileModal.module.scss"));
function ProfileModal() {
    var _a;
    (0, useCurrentAccountTabId_1.default)(accountTabs_1.TAB_IDS.PROFILE);
    const { t } = (0, react_i18next_1.useTranslation)('profile');
    const [editMode, setEditMode] = (0, react_1.useState)(false);
    const [isSubmitted, setIsSubmitted] = (0, react_1.useState)(false);
    const [isProfileEditMode, setIsProfileEditMode] = (0, react_1.useState)(false);
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(false);
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { dispatchUpdateUserInfo, dispatchUpdateAddressDataAction, dispatchUpdateDistributorInfoAction } = (0, redux_1.bindActionCreators)({
        dispatchUpdateUserInfo: actions_1.updateUserInfoAction,
        dispatchUpdateAddressDataAction: actions_2.updateAddressDataAction,
        dispatchUpdateDistributorInfoAction: actions_1.updateDistributorInfoAction,
    }, (0, react_redux_1.useDispatch)());
    const closeHandler = () => {
        navigate(-1);
    };
    const profileEditModeHandler = (state) => setIsProfileEditMode(state);
    const editButtonHandler = () => {
        setEditMode(!editMode);
        setIsProfileEditMode(false);
        setIsSubmitted(false);
    };
    const editorButton = (react_1.default.createElement(ElementDropdown_1.ElementDropdown, { element: react_1.default.createElement("div", { className: ProfileModal_module_scss_1.default.wrapper },
            react_1.default.createElement("div", { role: "button", tabIndex: 0, className: ProfileModal_module_scss_1.default.editor },
                react_1.default.createElement("img", { className: isProfileEditMode ? ProfileModal_module_scss_1.default.active : '', src: assets_1.svgBasicGroup, alt: "Group" }),
                react_1.default.createElement("img", { src: assets_1.svgBasicEdit, alt: "Edit" }))), placement: "left-start", dropdown: react_1.default.createElement(EditProfileDropdown_1.default, { editHandler: editButtonHandler }), activeStateHandler: profileEditModeHandler }));
    const submitHandler = () => {
        setEditMode(false);
        setIsSubmitted(true);
    };
    const updateUserInfo = (updateDate) => {
        dispatchUpdateUserInfo(updateDate);
    };
    const updateDistributorInfo = (updateDate, addressData, distributorData) => {
        dispatchUpdateDistributorInfoAction(distributorData);
        dispatchUpdateAddressDataAction(addressData);
        dispatchUpdateUserInfo(updateDate);
    };
    const renderUserProfileView = (userRole) => {
        switch (userRole) {
            case consts_1.UserRoles.customer:
                return (react_1.default.createElement(CustomerProfileView_1.default, { editMode: editMode, isSubmitted: isSubmitted, submitHandler: updateUserInfo, disableSubmit: setIsDisabled }));
            case consts_1.UserRoles.distributor:
                return (react_1.default.createElement(DistributorProfileView_1.default, { editMode: editMode, isSubmitted: isSubmitted, submitHandler: updateDistributorInfo, disableSubmit: setIsDisabled }));
            case consts_1.UserRoles.admin:
                return (react_1.default.createElement(AdminProfileView_1.default, { editMode: editMode, isSubmitted: isSubmitted, submitHandler: updateUserInfo, disableSubmit: setIsDisabled }));
            default:
                return null;
        }
    };
    return (react_1.default.createElement("div", { className: ProfileModal_module_scss_1.default.overlay },
        react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, "My Profile | TBUILD")),
        react_1.default.createElement("div", { className: ProfileModal_module_scss_1.default.window },
            react_1.default.createElement("div", { className: ProfileModal_module_scss_1.default.modal },
                react_1.default.createElement(ProfileHeadline_1.default, { user: user, closeHandler: closeHandler, activeBlock: !editMode ? editorButton : (0, ChangeCredentials_1.profileButtons)(editButtonHandler, submitHandler, isDisabled, t) }),
                renderUserProfileView((_a = user === null || user === void 0 ? void 0 : user.userType) === null || _a === void 0 ? void 0 : _a.name)))));
}
exports.default = ProfileModal;
